import { useRef, useEffect } from "react";
import { stub } from "@nbcnews/analytics-framework";
import { isEqual } from "lodash";
function useReportAnalyticsMetadata(metadata, instanceId) {
  const registered = useRef(false);
  const metadataRef = useRef(
    /** @type {OptionalMetadata} */
    void 0
  );
  useEffect(() => {
    if (!registered.current) {
      stub("register", ["sigma_cvsdk_playerInit", "sigma_cvsdk_updatedMetadata"]);
      registered.current = true;
    }
    if (!isEqual(metadataRef.current, metadata)) {
      metadataRef.current = metadata;
      stub("track", "sigma_cvsdk_updatedMetadata", { ...metadata, omegaInstanceId: instanceId });
    }
  });
}
export {
  useReportAnalyticsMetadata
};
//# sourceMappingURL=useReportAnalyticsMetadata.js.map
